import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl, thriweMarketPlaceUaeUrl, thriweMarketPlaceUrl } from '../../../../../Containers/Config';
import { Constant } from '../../../../../Containers/Helpers/constant';
import apiCall from '../../../apiCall';
import { GET_ANNOUNCEMENT_GOLBE, GET_ANNOUNCEMENT_GOLBE_ERROR, GET_ANNOUNCEMENT_GOLBE_SUCCESS } from '../../../actionType';

function* getAnnouncementForGlobe({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/announcements`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        // 'Project-Code': 'GLOBE_TOYOTA',
        ...customHeaders,
      },
      data: payload?.data,
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_ANNOUNCEMENT_GOLBE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_ANNOUNCEMENT_GOLBE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_ANNOUNCEMENT_GOLBE_ERROR, payload: error });
  }
}

export function* watchgetAnnouncementForGlobe() {
  yield takeEvery(GET_ANNOUNCEMENT_GOLBE, getAnnouncementForGlobe);
}

function* getAnnouncementForGlobeSaga() {
  yield all([fork(watchgetAnnouncementForGlobe)]);
}

export default getAnnouncementForGlobeSaga;
